import { QUESTION_AND_SCORE_DESCRIPTION_PER_DOMAIN } from './screenerQuestions';

export const PUBLIC_SCREENER_QUESTION_AND_SCORE_DESCRIPTION_PER_DOMAIN = QUESTION_AND_SCORE_DESCRIPTION_PER_DOMAIN;
